import { HashRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import "./core/i18n/i18n";
import { ThemeProvider } from "@mui/material";
import { APP_BASE_PATHNAMES } from "./core/consts/consts";
import muiTheme from "./MuiTheme";
import { MyNexarContextProvider } from "./components/my-nexar-context/my-nexar-context";
import AppWrapper from "./domains/app-wrapper";
import NotFound from "./domains/not-found";
import Login from "./domains/login/screens/login/login";
import ConnectGateway from "./domains/connect/screens/gateway/gateway";
import MyNexar from "./domains/mynexar/screens/mynexar/mynexar";
import SubscriptionDetails from "./domains/connect/screens/subscription-details/subscription-details";
import { useDI } from "./core/di";
import { IntercomProvider, useIntercom } from 'react-use-intercom';

const INTERCOM_APP_ID = 'ueg2aytx';

function App() {
  const { logger, analytics } = useDI();
  logger?.setup();
  analytics?.setup();

  const queryString = window.location.search;
  const queryParams = new URLSearchParams(queryString);
  const app = queryParams.get('app')
  if (app) sessionStorage.setItem('app', app);


  return (
    <HashRouter>
      <MyNexarContextProvider>
      <IntercomProvider appId={INTERCOM_APP_ID} autoBoot>
        <ThemeProvider theme={muiTheme}>
          <Routes>
            <Route path="/" element={<AppWrapper />}>
              <Route index element={<MyNexar />} />
              <Route path="*" element={<NotFound />} />
              <Route
                path={APP_BASE_PATHNAMES.CONNECT}
                element={<ConnectGateway />}
              >
                <Route
                  path={APP_BASE_PATHNAMES.SUBSCRIPTION_DETAILS}
                  element={<SubscriptionDetails />}
                />
              </Route>
              <Route path={APP_BASE_PATHNAMES.LOGIN} element={<Login />} />
            </Route>
          </Routes>
        </ThemeProvider>
        </IntercomProvider>
      </MyNexarContextProvider>
    </HashRouter>
  );
}

export default App;
